export type CustomQueryOptions = {
  cacheTime?: number;
  enabled?: boolean;
  retry?: boolean | number;
  staleTime?: number;
  suspense?: boolean;
};

export enum QueryKey {
  AccountMetadata = 'accountMetadata',
  AccountOwners = 'accountOwners',
  Accounts = 'accounts',
  ActivePartnerFeatures = 'activePartnerFeatures',
  CommunicationEligibilities = 'communicationEligibilities',
  CurrentUserAccount = 'currentUserAccount',
  DeduplicationConfigurations = 'deduplicationConfigurations',
  DemandContracts = 'demandContracts',
  DemandSubAccountInventoryCaps = 'demandSubAccountInventoryCaps',
  ExpectedEarningsShares = 'expectedEarningsShares',
  IssuerSync = 'issuerSync',
  LeadHydrationConfigs = 'leadHydrationConfigs',
  MciConversionsReports = 'mciConversionsReports',
  MciConversionsReportsMostRecent = 'mciConversionsReportsMostRecent',
  MciOffersReports = 'mciOffersReports',
  MciOffersReportsMostRecent = 'mciOffersReportsMostRecent',
  MciRejectionsReports = 'mciRejectionsReports',
  MciRejectionsReportsMostRecent = 'mciRejectionsReportsMostRecent',
  Notifications = 'notifications',
  OfferCatalogOffers = 'offerCatalogOffers',
  OfferCatalogProducts = 'offerCatalogProducts',
  OfferCatalogProductsV2 = 'offerCatalogProductsV2',
  OnboardingContractSignatures = 'onboardingContractSignatures',
  OnboardingContracts = 'onboardingContracts',
  OriginatorStaticOffersByProductType = 'originatorStaticOffersByProductType',
  PartnerPages = 'partnerPages',
  PerformanceSummaryFunnel = 'performanceSummaryFunnel',
  PerformanceSummaryPayout = 'performanceSummaryPayout',
  ProfileMeta = 'profileMeta',
  SaasPlans = 'saasPlans',
  SaasSubscription = 'saasSubscription',
  SaasTrial = 'saasTrial',
  SampleDemandContractFinancials = 'sampleDemandContractFinancials',
  SubAccounts = 'subAccounts',
  SubAccountsById = 'subAccountsById',
  SupplyContracts = 'supplyContracts',
  SupplyDemandInclusionData = 'supplyDemandInclusionData',
  SupplyMigrationSettings = 'supplyMigrationSettings',
}
